import { connect } from 'react-redux'
import Insights from './Insights'

const mapStateToProps = (state: TopHap.StoreState) =>
  ({ insightsData: state.property.insightsData })

export default connect(mapStateToProps)(Insights)
